import React from "react";
import { Route, Routes } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { Pages } from "./navigation/routes/routes";
import { ProtectedRoute, PublicRoute } from "./navigation/layout";
import { ThemeModeProvider } from "./context/ThemeModeContext";
import AuthProvider from "./context/AuthProvider";
import { queryClient } from "./queryClient";

const App: React.FC = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeModeProvider>
      <AuthProvider>
        <Routes>
          {Pages.map((page) => (
            <Route
              key={page.path}
              path={page.path}
              element={
                page.protected ? (
                  <ProtectedRoute>{page.component}</ProtectedRoute>
                ) : (
                  <PublicRoute>{page.component}</PublicRoute>
                )
              }
            />
          ))}
        </Routes>
      </AuthProvider>
    </ThemeModeProvider>
  </QueryClientProvider>
);

export default App;
